module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAKJJREFUGBljZACCI+fOSTH9/tfP8P+/C4jPwMi45x8rU6GNkdEzxmMXLkgz/PxzSVxUhFdAgI8VJP/hw6ffL1+/+czAzqLHApTsB0mKigiBJUEKoGxeoKJ+pv//GVwEoTpBkjAAMg0kxwQTQKcZoQJMjIwMe94D7URXABIDycEceRnoDh6YVSBJoP1fgI7UBZsE9Uk/yE6QSSCdQMlCKwODpwDPFUS+ODLpygAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/sprite-icons/marker-pin-unavailable.png
// module id = 1189
// module chunks = 0